/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Share_Noaccessyet3Inputs */

const en_coinvestments_share_noaccessyet3 = /** @type {(inputs: Coinvestments_Share_Noaccessyet3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No access yet`)
};

/**
* | output |
* | --- |
* | "No access yet" |
*
* @param {Coinvestments_Share_Noaccessyet3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_share_noaccessyet3 = /** @type {((inputs?: Coinvestments_Share_Noaccessyet3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Share_Noaccessyet3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_share_noaccessyet3(inputs)
});
export { coinvestments_share_noaccessyet3 as "coInvestments_share_noAccessYet" }